import { useEffect } from "react";
import { useAuth } from "@/lib/auth-context";
import { initErrorMonitoring, setErrorUser } from "@/lib/error-monitoring";

/**
 * Mounts once at the root: installs the browser error listeners after
 * hydration and keeps the reported user id in sync with the session.
 */
export function ErrorMonitor() {
  const { user } = useAuth();

  useEffect(() => {
    initErrorMonitoring();
  }, []);

  useEffect(() => {
    setErrorUser(user?.id ?? null);
  }, [user?.id]);

  return null;
}
